import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import MasterBase from "../components/MasterLayout";
import { readonly } from '../modules/formstore';
import { isEmpty, getformid, getcontroller, getsubkey } from '../modules/appLibrary';

export const Performance = props => {

    const dispatch = useDispatch();
    const formid = getformid("Performance", props.location.search);
    const controller = getcontroller("Performance", props.location.search);
    const subkey = getsubkey(props.location.search);
    const search = useLocation().search;


    const navmenu = [
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
    ]
    //動作抑止
    const suppressaction = [
    ];
    const actionurl = {
        "getlist": "performance/GetList",
    }


    function RowStyle(params) {
        if (params.node.data["sortkey"].slice(-2) !== "_9") {   //集計行
            return { background: params.context.theme.body.accentback };
        }
    }

    return (
         <div>
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                condition={true}
                navmenu={navmenu}
                suppressaction={suppressaction}
                list={true}
                noclear={true}
                exRowStyle={RowStyle}
            />
        </div>
    );
};
